import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AuthService} from '../service/auth.service';

@Component({
    selector: 'app-login-redirect',
    templateUrl: './login-redirect.component.html',
    styleUrls: ['./login-redirect.component.css']
})
export class LoginRedirectComponent implements OnInit {

    signin: FormGroup;
    singinformtouched: boolean = false;
    message: string;
    constructor(private singinfb: FormBuilder, private authservice: AuthService) {
    }

    ngOnInit() {
        localStorage.clear();

        this.signin = this.singinfb.group({
            'email': ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
            'password': ['', [Validators.required]]
        })
        this.authservice.hideshowheader(false);


    }

    userSignin(data) {
        this.singinformtouched = true;
        if (this.signin.valid) {
            this.authservice.signin(data).subscribe(
              (response: singininterface) => {
                  if (response.status) {
                      if (window.parent && window.parent !== window) {
                          const message = {
                              type: 'LOGIN_SUCCESS',
                              token: response.token,
                              user_slug: response.user_slug,
                              tutor_ornot: response.tutor_ornot,
                              timestamp: Date.now()
                          };

                          window.parent.postMessage(message, 'https://park.bz');

                      } else {
                          localStorage.setItem('auth-token', response.token);
                          localStorage.setItem('user_slug', response.user_slug);
                          localStorage.setItem('tutor_ornot', response.tutor_ornot);
                          window.open('https://livebook.designleadership.academy/', '_blank');
                      }
                  }
              }
            );
        }
    }
}


export interface singininterface {
    status: boolean,
    message: string,
    token?: any,
    user_slug: any;
    tutor_ornot: any,

}
